export enum ImageSize {
  Backdrop = 'backdropSizes',
  Logo = 'logoSizes',
  Poster = 'posterSizes',
  Profile = 'profileSizes',
  Still = 'stillSizes',
}

export enum BackdropSize {
  SM,
  MD,
  LG,
  XL,
}

export enum LogoSize {
  XXS,
  XS,
  SM,
  MD,
  LG,
  XL,
  XXL,
}

export enum PosterSize {
  XXS,
  XS,
  SM,
  MD,
  LG,
  XL,
  XXL,
}

export enum ProfileSize {
  SM,
  MD,
  LG,
  XL,
}

export enum StillSize {
  SM,
  MD,
  LG,
  XL,
}
